import React from "react";
import { Outlet } from "react-router-dom";
import MTopBar from "../ui/atoms/MTopBar";
import { MExit } from "../ui/atoms/MExit";
import MFooterNavigation from '../ui/atoms/MFooterNavigation';

/**
 * NoFooterLayout: Used for 3rd Level Screens.
 * Renders a top bar, main content, and optionally footer navigation
 */
interface NoFooterLayoutProps extends React.PropsWithChildren<{}> {
  exitPath?: string;
  hideExit?: boolean;
  hideBack?: boolean;
  level?: number;
  showGradient?: boolean;
  showTopBarGradient?: boolean;
  showFooter?: boolean;
  onEdit?: () => void;
  showEdit?: boolean;
  onBack?: () => void;
}

const NoFooterLayout: React.FC<NoFooterLayoutProps> = ({
  children,
  exitPath,
  hideExit,
  hideBack = false,
  level = 2,
  showGradient = false,
  showTopBarGradient = false,
  showFooter = false,
  onEdit,
  showEdit = false,
  onBack,
}) => {
  return (
    <div
      className="flex flex-col relative"
      style={{
        background: showGradient
          ? "linear-gradient(181deg, #FBF6FF 77.96%)"
          : "#fff",
      }}
    >
      <MTopBar hideProfilePicker hideBack={hideBack} onEdit={onEdit} showEdit={showEdit} onBack={onBack} showTopBarGradient={showTopBarGradient} />
      <MExit
        className="absolute top-[0] right-[24px] mt-[64px] z-10"
        path={exitPath}
        hideExit={hideExit}
        level={level}
      />

      <main 
        className={`flex-1 overflow-auto overflow-x-hidden ${!showGradient ? 'bg-white' : ''}`}
        style={{ maxHeight: showFooter ? 'calc(var(--vh, 1vh) * 100 - 128px - 64px)' : 'calc(var(--vh, 1vh) * 100 - 128px)' }}
      >
        {children ? children : <Outlet />}
      </main>
      
      {showFooter && <MFooterNavigation />}
    </div>
  );
};

export default NoFooterLayout;